<style>
   @import './About.css';
</style>

<template>
  <div class="about">

  <div v-if="!userLog">
      Pas de bras, pas de chocolat
    </div>
  <div v-if="userLog">

    <h1 v-on:click="apiClick()" >C'est un titre à cliquer en ligne puis hors ligne !</h1>
      <span>{{introLue1}} : {{ dataLueCache.title }}</span>
      <br/>
      <span>{{introLue2}} : {{ dataLueDB.title }}</span>

    <h1 >C'est un titre à ne pas cliquer ...</h1>
      <span>{{introLueDebutPoeme}} : {{ dataLueDebutPoeme.title }}</span>
      <br/>
      <span>{{introLueFinPoeme}} : {{ dataLueFinPoeme.title }}</span>

    </div>
  </div>

</template>


<script>
    

import { addeoData } from "../js/api/datas.js";
import { ApiUser } from '../js/api/index.js'


export default {

    data(){
        return {
            fromAxios1 : {},
            fromAxios2 : {},
            intro1 :"",
            intro2 :"",
            debutPoeme : {},
            finPoeme : {},
            introDebutPoeme :"",
            introFinPoeme :"",

        }
    }, 
    mounted: function () {
    //created: function () {

            ApiUser.getConstToto1()
                .then(response => {
                    if ((typeof response == "undefined")) {
                        console.log("erreur lireDebutPoemeBD");
                    }
                    else {
                        console.log("response", response);
                        if ((typeof response !== "undefined")  && (typeof response[0] !== "undefined")) {
                            this.debutPoeme = response[0] ;
                            this.introDebutPoeme = "Lu en DB";
                            }
                        else {
                            console.log("erreur lireDebutPoemeBD");
                        }
                        console.log("title : ", this.debutPoeme.title);
                    }
                })
                .catch(e => {
                    console.log("pb indexedDb", e);
                });

            return ApiUser.getUserToto2()
                .then(response => {
                    if ((typeof response == "undefined")) {
                        console.log("erreur lireFinPoemeBD");
                    }
                    else {
                        console.log("response", response);
                        if ((typeof response !== "undefined") && (typeof response[0] !== "undefined")) {
                            this.finPoeme = response[0] ;
                            this.introFinPoeme = "Lu en DB";
                            }
                        else {
                            console.log("erreur lireFinPoemeBD");
                        }
                        console.log("title : ", this.finPoeme.title);
                    }
                })
                .catch(e => {
                    console.log("pb indexedDb", e);
                });

    },
    computed: {

        userLog() {
                //return true
                return this.$parent.authenticated
            },

         dataLueCache() {
             return this.fromAxios1
        },
         dataLueDB() {
             return this.fromAxios2
        },
         introLue1() {
             return this.intro1
        },
         introLue2() {
             return this.intro2
        },
         dataLueDebutPoeme() {
             return this.debutPoeme
        },
         dataLueFinPoeme() {
             return this.finPoeme
        },
         introLueDebutPoeme() {
             return this.introDebutPoeme
        },
         introLueFinPoeme() {
             return this.introFinPoeme
        },

    }, 

    methods: {

        ahBenNon: function (e) {  
            /*
            var confirmationMessage = "Le rafraichissement de la page est bloqué pour permettre son usage hors ligne !";

console.log("Le rafraichissement de la page est bloqué pour permettre son usage hors ligne : ", e)
  e.preventDefault();
            
            e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
            return confirmationMessage;              // Gecko, WebKit, Chrome <34
            //alert(confirmationMessage);
            */
        },
        apiClick: function () {

            
            addeoData.lireDebutPoeme()
                .then(response => {
                    if ((typeof response == "undefined") || ((typeof response.data == "undefined") && (typeof response[0] == "undefined")) ) {
                        console.log("addeoData pb response");
                    }
                    else {
                        console.log("response", response);
                        if (typeof response[0] !== "undefined") {
                            this.fromAxios1 = response[0] ;
                            this.intro1 = "Lu en DB";
                            }
                        else {
                            this.fromAxios1 = response.data ;
                            this.intro1 = "Lu en Ajax";
                        }
                        console.log("title : ", this.fromAxios1.title);
                    }
                })
                .catch(e => {
                    console.log("pb indexedDb", e);
                });

            return addeoData.lireFinPoeme()
                .then(response => {
                    if ((typeof response == "undefined") || ((typeof response.data == "undefined") && (typeof response[0] == "undefined")) ) {
                        console.log("addeoData pb response");
                    }
                    else {
                        console.log("response", response);
                        if (typeof response[0] !== "undefined") {
                            this.fromAxios2 = response[0] ;
                            this.intro2 = "Lu en DB";
                            }
                        else {
                            this.fromAxios2 = response.data ;
                            this.intro2 = "Lu en Ajax";
                        }
                        console.log("title : ", this.fromAxios2.title);
                    }
                })
                .catch(e => {
                    console.log("pb indexedDb", e);
                });
            
            }
    }

}
</script>
